"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGMenuScene = void 0;
const FBDTextLayout_1 = require("./FBDTextLayout");
const FBDMenuOption_1 = require("./FBDMenuOption");
const FBDMenuSelectOption_1 = require("./FBDMenuSelectOption");
const KHDepth_1 = require("./KH/KHDepth");
const FBDMenuSelectOptionWithValues_1 = require("./FBDMenuSelectOptionWithValues");
const KHContainer_1 = require("./KH/KHContainer");
const KHScrollView_1 = require("./KH/KHScrollView");
const CTGBaseScene_1 = require("./CTGBaseScene");
const CTGOptionArrow_1 = require("./Display/CTGOptionArrow");
const CTG_1 = require("./CTG");
const CTGCardView_1 = require("./Display/CTGCardView");
const CTGCard_1 = require("./Logic/CTGCard");
// We want to block scrolling if mouse is over game area.
let phaser_game_block_scroll = false;
window.addEventListener("wheel", function (e) {
    if (phaser_game_block_scroll)
        e.preventDefault();
}, { passive: false });
class CTGMenuScene extends CTGBaseScene_1.CTGBaseScene {
    constructor(scene_name) {
        super(scene_name);
    }
    init(data) {
        super.init(data);
        this.init_data = data;
    }
    create() {
        super.create();
        this.input.mouse.disableContextMenu();
        this.all_options = null;
        this.options = [];
        this._cards = [];
        this.last_option = null;
        this.back_option = null;
        this.selected_option = -1;
        this.game_width = Number(this.game.config.width);
        this.game_height = Number(this.game.config.height);
        this.descriptionOverride = null;
        const audio_scene = CTG_1.game_manager.add_or_get_audio_scene(this);
        audio_scene.play('main_menu', true, true, 0.5);
        // This will block scrolling in this scene if mouse is over the game area.
        this.input.on('gameout', function () {
            phaser_game_block_scroll = false;
        });
        this.input.on('gameover', function () {
            phaser_game_block_scroll = true;
        });
        this.add.tileSprite(0, 0, this.game_width, this.game_height, 'dither').setTint(0x037c2c).setOrigin(0).setDepth(KHDepth_1.Depth.Background);
        this.starting_option_height = 10;
        this.add.sprite(-5, 1, 'arrow').setOrigin(0).setDepth(KHDepth_1.Depth.UI);
        this.title_text = this.add.bitmapText(2, 2, "font", "LONGISH NAME", 6).setTint(0x0).setOrigin(0).setDepth(KHDepth_1.Depth.UI);
        this.description_text = this.add.bitmapText(this.game_width * 2, this.starting_option_height, "font", "", 12).setOrigin(0).setDepth(KHDepth_1.Depth.UI);
        let can_go_back = this.init_data && this.init_data.previous_scene;
        this.scrollContents = new KHContainer_1.KHContainer(this, 0, 0, this.game_width, this.game_height - 12 - this.starting_option_height).setDepth(KHDepth_1.Depth.UI);
        this.scrollView = new KHScrollView_1.KHScrollView(this, 0, this.starting_option_height, this.game_width, this.game_height - (can_go_back ? 10 : 0) - this.starting_option_height, this.scrollContents).setDepth(KHDepth_1.Depth.Game);
        // Block touches in scroll view outside of bounds.
        this.input_blocker_top = this.add.sprite(32, this.starting_option_height / 2, 'pixel').setDisplaySize(64, this.starting_option_height).setAlpha(0.00001).setInteractive().setDepth(KHDepth_1.Depth.UI);
        this.input_blocker_bottom = this.add.sprite(32, this.game_height - (this.starting_option_height / 2), 'pixel').setDisplaySize(64, this.starting_option_height).setAlpha(0.00001).setInteractive().setDepth(KHDepth_1.Depth.UI);
        this.show_text_background = false;
        if (this.show_text_background) {
            this.text_backgrounds = this.add.graphics({ x: 0, y: 0, fillStyle: { color: 0xff00ff, alpha: 1 } }).setDepth(KHDepth_1.Depth.Game);
            this.text_backgrounds.fillRect(5, 5, 10, 10);
        }
        this.text_formatter = new FBDTextLayout_1.FBDTextLayout(this.game_width / 2, 6, 2);
        this.move_sound = this.sound.add('sfx_destroy');
        if (can_go_back) {
            this.addBackOption();
        }
        this.next_placement = 0;
        this.make_cards();
        this.onCreate();
        this.scrollView.recomputeForBounds();
    }
    getCurrentTime() {
        return this.time.now;
    }
    // Called after create is finished in parent scene.
    onCreate() {
    }
    make_cards() {
        this._card_idx = 0;
        const card_count = 6;
        for (let i = 0; i < card_count; i++) {
            let card = CTGCard_1.CTGCard.fromNumber(this._card_idx);
            card.showing_front = false;
            card.y = (4 - i) * (CTG_1.card_size[1] + 1);
            card.x = Math.floor(64 - CTG_1.card_size[0] / 2 - 1);
            this._card_idx = (this._card_idx + 1 % 52);
            const card_view = new CTGCardView_1.CTGCardView(this, card, null);
            this._cards.push(card_view);
            this.add.existing(card_view);
            // card_view.flip_card(500, i * 400, () => {
            //     this.update_flip(card_view);
            // })
        }
    }
    update_flip(card_view) {
        card_view.flip_card(500, 500, () => this.update_flip(card_view));
    }
    update(now, delta) {
        const move_speed = 10;
        for (let i = 0; i < this._cards.length; i++) {
            const card_view = this._cards[i];
            card_view.card.y += move_speed * delta / 1000;
            if (card_view.card.y > 64 + CTG_1.card_size[1] / 2) {
                card_view.card.y -= this._cards.length * (CTG_1.card_size[1] + 1);
                card_view.card.suit = Math.floor(this._card_idx / 13) + 1;
                card_view.card.rank = (this._card_idx % 13) + 1;
                card_view.update_front();
                this._card_idx = (this._card_idx + 1) % 52;
            }
            card_view.card.move(card_view.card.x, card_view.card.y);
        }
    }
    set_prev_selected() {
        let idx = this.selected_option;
        if (idx == -1)
            idx = 0;
        const options = this.get_all_options();
        for (let i = 1; i <= options.length; i++) {
            const adj_idx = (idx - i + options.length) % options.length;
            if (options[adj_idx].selectable) {
                this.update_selected(this.all_options[adj_idx]);
                return;
            }
        }
    }
    set_next_selected(playSound = true) {
        let idx = this.selected_option;
        const options = this.get_all_options();
        for (let i = 1; i <= options.length; i++) {
            const adj_idx = (idx + i + options.length) % options.length;
            if (options[adj_idx].selectable) {
                this.update_selected(this.all_options[adj_idx], playSound);
                return;
            }
        }
    }
    get_all_options() {
        if (!this.all_options) {
            if (this.last_option) {
                this.last_option.idx = this.options.length;
                this.all_options = this.options.concat([this.last_option]);
            }
            else {
                this.all_options = this.options;
            }
        }
        return this.all_options;
    }
    animate_select(selected) {
        selected.option.animate_select();
    }
    unanimate_select(selected) {
        selected.option.animate_deselect();
    }
    updateDescriptionText(text) {
        if (this.description_text != null) {
            return;
        }
        if (this.descriptionOverride != null) {
            this.description_text.setText(this.descriptionOverride.toUpperCase());
        }
        else
            this.description_text.setText(text);
    }
    update_selected(selected, playSound = true) {
        const old_option = this.get_all_options()[this.selected_option];
        if (old_option) {
            this.unanimate_select(old_option);
            this.updateDescriptionText("");
        }
        if (!selected) {
            this.selected_option = -1;
            return;
        }
        this.selected_option = selected.idx;
        if (playSound)
            this.move_sound.play();
        let bounds = selected.option.text.getTextBounds(true);
        // if (selected != this.back_option) {
        //     this.scrollView.scrollToBounds(selected.option.x, selected.option.y, bounds.local.width, bounds.local.height, 2);
        // }
        this.updateDescriptionText(this.text_formatter.format_text(selected.description));
        this.animate_select(selected);
    }
    on_left(selected) {
        if (selected.back_callback) {
            selected.back_callback();
        }
        selected.updateText();
        this.updateDescriptionText(this.text_formatter.format_text(selected.description));
    }
    on_right(selected) {
        if (selected.callback) {
            selected.callback();
        }
        selected.updateText();
        this.updateDescriptionText(this.text_formatter.format_text(selected.description));
    }
    setTitle(title) {
        this.title_text.setText(title.toUpperCase());
    }
    startScene(name, data = {}, disallow_back = false, is_going_back = false, animate_transition = true) {
        if (is_going_back) {
            data = this.init_data.init_data;
        }
        else if (!disallow_back) {
            const back_data = this.init_data ? this.init_data : {};
            data.previous_scene = this.scene.key;
            data.init_data = back_data;
        }
        animate_transition = false;
        if (animate_transition) {
            data.animate_in = true;
            this.animate_hide_scene(() => {
                this.scene.start(name, data);
            });
        }
        else {
            this.scene.start(name, data);
        }
    }
    addBackOption() {
        this.back_option = new FBDMenuOption_1.FBDMenuOption("Back", "Go to the previous screen.", true, () => { this.startScene(this.init_data.previous_scene, null, false, true); });
        this.addMenuOption(this.back_option, true, true);
    }
    addPreferenceOptionSingleDescription(text, description, options, callback, start_idx = 0) {
        let descriptions = [];
        for (let i = 0; i < options.length; i++) {
            descriptions.push(description);
        }
        const option = new FBDMenuSelectOption_1.FBDMenuSelectOption(text, options, descriptions, callback, start_idx);
        this.addMenuOption(option);
        return option;
    }
    addPreferenceOption(text, descriptions, options, callback, start_idx = 0) {
        const option = new FBDMenuSelectOption_1.FBDMenuSelectOption(text, options, descriptions, callback, start_idx);
        this.addMenuOption(option);
        return option;
    }
    addPreferenceOptionWithValues(text, options, descriptions, objs, callback = null, start_idx = 0) {
        const option = new FBDMenuSelectOptionWithValues_1.FBDMenuSelectOptionWithValues(text, options, objs, descriptions, callback, start_idx);
        this.addMenuOption(option);
        return option;
    }
    addOption(text, description, callback, selectable = true, last = false) {
        return this.addMenuOption(new FBDMenuOption_1.FBDMenuOption(text, null, selectable, callback), selectable, last);
    }
    addText(text) {
        return this.addMenuOption(new FBDMenuOption_1.FBDMenuOption(text, null, null, null), null, null);
    }
    addMenuOption(menu_option, selectable = true, last = false) {
        menu_option.text = menu_option.text ? menu_option.text.toUpperCase() : "";
        menu_option.description = menu_option.description ? menu_option.description.toUpperCase() : "";
        let y = last ? this.game_height - 9 : 9 * this.options.length;
        let x = last ? 5 : 2;
        let option = new CTGOptionArrow_1.CTGOptionArrow(this, menu_option.text, x, selectable, () => this.update_selected(menu_option), () => this.update_selected(null), () => this.on_right(menu_option), () => this.on_left(menu_option)).setY(y).setDepth(KHDepth_1.Depth.UI);
        this.add.existing(option);
        if (!last) {
            this.scrollContents.add(option);
            this.scrollContents.c_h = Math.max(this.scrollContents.c_h, option.y + 8);
        }
        menu_option.option = option;
        menu_option.idx = this.options.length;
        if (last) {
            this.last_option = menu_option;
        }
        else {
            this.options.push(menu_option);
        }
        return menu_option;
    }
}
exports.CTGMenuScene = CTGMenuScene;
